import { render, staticRenderFns } from "./MenuListItem.vue?vue&type=template&id=4dde9a08&scoped=true&"
import script from "./MenuListItem.vue?vue&type=script&lang=js&"
export * from "./MenuListItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuListItem.vue?vue&type=style&index=0&id=4dde9a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dde9a08",
  null
  
)

export default component.exports